// How long RTK Query keeps a result that no mounted component uses. It has to outlast the time a user
// spends on one page, or the data prefetched at startup is gone before they open the next one.
// The hour is not derived from anything; once the backend pushes change notifications, cached data
// can stay until one arrives.
export const keepUnusedDataFor = 60 * 60;
